import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  ${props => props.border ? 'border-right: 1px solid #dbdbdc;' : ''}
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  min-height: 50px;
`
const InfoContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: ${props => props.align};
  flex-direction: column;
`
const ProbabilityTitle = styled.div`
  line-height: 1.4;
  font-weight: 600;
  font-size: 16px;
  min-height: 40px;
`
const Bold = styled.div`
  color: ${props => props.color};
  font-size: 25px;
  font-weight: 600;
`
const Smaller = styled.div`
  color: ${props => props.color};
  font-size: 14px;
  font-style: italic;
  line-height: 13px;
`
const Percentage = styled.div`
  margin-bottom: 10px;
`

const Probability = ({ title, message, value, border, valueColor, messageColor }) => {
  return (
    <Container border={border}>
      <ProbabilityTitle>
        {title}
      </ProbabilityTitle>
      <InfoContainer align={value ? 'center' : 'flex-end'}>
        {
          value && (
            <Percentage>
              <Bold color={valueColor}>
                {value}
              </Bold>
            </Percentage>
          )
        }
        <Smaller color={messageColor}>
          {message}
        </Smaller>
      </InfoContainer>
    </Container>
  )
}

Probability.propTypes = {
  border: PropTypes.bool,
  message: PropTypes.string,
  messageColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueColor: PropTypes.string
}

export default Probability
